module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-content"
  }, [_c('ul', {
    staticClass: "layout-menu"
  }, _vm._l((_vm.menuList), function(menuItem) {
    return _c('li', {
      class: {
        'selected': _vm.routePath === menuItem.path
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(menuItem.path)
        }
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "width": "16%",
        "src": '/static/icon/' + menuItem.icon + '.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(menuItem.title))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "layout-mainapp"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bed6b3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/layout.vue
// module id = 614
// module chunks = 16